import { ClipboardModule } from "@angular/cdk/clipboard";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { DatePipe, DecimalPipe, registerLocaleData } from "@angular/common";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import {
    APP_INITIALIZER,
    DoBootstrap,
    Injector,
    LOCALE_ID,
    NgModule,
} from "@angular/core";
import { createCustomElement } from "@angular/elements";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";
import { MatLegacyChipsModule as MatChipsModule } from "@angular/material/legacy-chips";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { MatLegacySlideToggleModule as MatSlideToggleModule } from "@angular/material/legacy-slide-toggle";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatStepperModule } from "@angular/material/stepper";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import {
    AnalyticsService,
    ConfigurationService,
} from "@niceltd/cxone-client-platform-services";
import { SpinnerModule as SpinnerSolModule } from "@niceltd/sol/spinner";
import {
    ConfigurationService as ConfigurationCoreService,
    DynamicLocaleId,
    LocalizationInitializer,
    TranslationPipe,
} from "@niceltd/cxone-core-services";
import { ButtonModule as ButtonSolModule } from "@niceltd/sol/button";
import { CardModule as SolCardModule } from "@niceltd/sol/card";
import { CheckboxModule as CheckboxSolModule } from "@niceltd/sol/checkbox";
import { ChipModule as SolChipModule } from "@niceltd/sol/chip";
import { DatePickerModule } from "@niceltd/sol/date-picker";
import { DateRangePickerModule } from "@niceltd/sol/date-range-picker";
import {
    DropdownModule,
    DropdownModule as DropdownSolModule,
} from "@niceltd/sol/dropdown";
import { FloatingMenuModule } from "@niceltd/sol/floating-menu";
import { GridModule as GridSolModule } from "@niceltd/sol/grid";
import { InlineNotificationModule } from "@niceltd/sol/inline-notification";
import { ModalModule as ModalSolModule } from "@niceltd/sol/modal";
import { NumericSelectorModule as NumericSelectorSolModule } from "@niceltd/sol/numeric-selector";
import { OmnibarModule as OmnibarSolModule } from "@niceltd/sol/omnibar";
import { RadioModule as RadioSolModule } from "@niceltd/sol/radio-button";
import { RangeSliderModule as RangeSliderSolModule } from '@niceltd/sol/range-slider';
import { SelectedTagsModule as SelectedTagsSolModule } from "@niceltd/sol/selected-tags";
import { SlideToggleModule as SlideToggleSolModule } from "@niceltd/sol/slide-toggle";
import { StatusIndicatorModule as SolStatusIndicatorModule } from "@niceltd/sol/status-indicator";
import { TabsModule as SolTabsModule } from "@niceltd/sol/tabs";
import { TextAreaModule as SolTextAreaModule } from "@niceltd/sol/text-area";
import { TextInputModule as SolTextInput } from "@niceltd/sol/text-input";
import { TimePickerModule } from "@niceltd/sol/time-picker";
import { ToastrManagerModule as ToastrManagerSolModule } from "@niceltd/sol/toastr";
import { ButtonToggleGroupModule as SolButtonToggleGroupModule } from "@niceltd/sol/toggle-group";
import { TooltipModule as SolTooltipModule } from "@niceltd/sol/tooltip";
import { WizardModule } from "@niceltd/sol/wizard";
import { EditorModule } from "@tinymce/tinymce-angular";
import { AgGridModule } from "ag-grid-angular";
import { GridsterModule } from "angular-gridster2";
import { I18NEXT_SERVICE, I18NextModule, ITranslationService } from "angular-i18next";
import { HighchartsChartModule } from "highcharts-angular";
import { InitOptions, LanguageDetectorModule } from "i18next";
import { NgChartsModule } from "ng2-charts";
import { NouisliderModule } from "ng2-nouislider";
import { PopoverModule } from "ngx-bootstrap/popover";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { ImageCropperModule } from "ngx-image-cropper";
import { OverlayscrollbarsModule } from "overlayscrollbars-ngx";
import { ColorPickerModule } from "primeng/colorpicker";
import { CVLocalizedTextDirective } from "src/app/reusables/localization/cv-localized-text.directive";
import { AgGridGroupHeaderTooltipComponent } from "src/shared/ag-grid-components/ag-grid-group-header-tooltip/ag-grid-group-header-tooltip.component";
import { createNg1Wrapper } from "src/shared/create_ng1_wrapper";
import { GenericExportComponent } from "src/shared/generic-export/generic-export.component";
import { AngularModuleServiceBase } from "src/shared/services/angular-module-service-base";
import { AboutComponent } from "./about/about.component";
import { CompanyEditSsoComponent } from "./admin/company-settings/company-edit-sso/company-edit-sso.component";
import { CompanySettingsComponent } from "./admin/company-settings/company-settings.component";
import { CXOneFirstPhaseIntegrationComponent } from "./admin/cxone-first-phase-integration/cxone-first-phase-integration.component";
import { LaunchWallboardComponent } from "./admin/launch-wallboard/launch-wallboard.component";
import { ObjectiveAddEditComponent } from "./admin/objectives/objective-add-edit/objective-add-edit.component";
import { ObjectiveAssignComponent } from "./admin/objectives/objective-assign/objective-assign.component";
import { ObjectiveGroupsAssignedComponent } from "./admin/objectives/objective-groups-assigned/objective-groups-assigned.component";
import { ObjectiveGroupsCardViewComponent } from "./admin/objectives/objective-groups-card-view/objective-groups-card-view.component";
import { ObjectiveLandingComponent } from "./admin/objectives/objective-landing/objective-landing.component";
import { ObjectiveMetricsAssignedComponent } from "./admin/objectives/objective-metrics-assigned/objective-metrics-assigned.component";
import { ObjectiveTimePipe } from "./admin/objectives/objective-time.pipe";
import { UsageStatsExportButtonComponent } from "./admin/usage-stats-export-button/usage-stats-export-button.component";
import { AccessUseradminComponent } from "./admin/user/access-useradmin/access-useradmin.component";
import { PageAccessCellRenderer } from "./admin/user/access-useradmin/page-access-cell/page-access-cell.component";
import { WidgetAccessCellRendererComponent } from "./admin/user/access-useradmin/widget-access-cell-renderer/widget-access-cell-renderer.component";
import { AddUserComponent } from "./admin/user/add-user/add-user.component";
import { AttributesUseradminComponent } from "./admin/user/attributes-useradmin/attributes-useradmin.component";
import { DashboardsUseradminComponent } from "./admin/user/dashboards-useradmin/dashboards-useradmin.component";
import { DetailsUseradminComponent } from "./admin/user/details-useradmin/details-useradmin.component";
import { GamificationDetailPageComponent } from "./admin/user/gamification-detail-page/gamification-detail-page.component";
import { GamificationPageComponent } from "./admin/user/gamification-page/gamification-page.component";
import { ImageUploadComponent } from "./admin/user/image-upload/image-upload.component";
import { PackagesUseradminComponent } from "./admin/user/packages-useradmin/packages-useradmin.component";
import { PermissionAssignBoxComponent } from "./admin/user/permission-assign-box/permission-assign-box.component";
import { PermissionsUseradminComponent } from "./admin/user/permissions-useradmin/permissions-useradmin.component";
import { SelectedUserLabelComponent } from "./admin/user/selected-user-label/selected-user-label.component";
import { UserAdminComponent } from "./admin/user/user-admin/user-admin.component";
import { UserListComponent } from "./admin/user/user-list/user-list.component";
import { AnnouncementsNewComponent } from "./announcements/announcements-new/announcements-new.component";
import { AnnouncementsComponent } from "./announcements/announcements.component";
import { AwardCardComponent } from "./dashboard/awards/award-card/award-card.component";
import { ContextMenuAwardsDialogComponent } from "./dashboard/awards/context-menu-awards-dialog/context-menu-awards-dialog.component";
import { DashboardFilterSlideoutComponent } from "./dashboard/dashboard-filter-slideout/dashboard-filter-slideout.component";
import { DashboardWindowComponent } from "./dashboard/dashboard-window/dashboard-window.component";
import { AgentStateDetailComponent } from "./dashboard/modals/agent-state-detail/agent-state-detail.component";
import { AgentStatesColorModalComponent } from "./dashboard/modals/agent-states-color-modal/agent-states-color-modal.component";
import { CreateNewReportModalComponent } from "./dashboard/modals/create-new-report-modal/create-new-report-modal.component";
import { DashboardAccessComponent } from "./dashboard/modals/dashboard-access/dashboard-access.component";
import { PermissionCellRendererComponent } from "./dashboard/modals/dashboard-access/permission-cell-renderer/permission-cell-renderer.component";
import { RoleSelectorCellRendererComponent } from "./dashboard/modals/dashboard-access/role-selector-cell-renderer/role-selector-cell-renderer.component";
import { DeleteSubscriptionComponent } from "./dashboard/modals/delete-subscription/delete-subscription.component";
import { SaveDashboardModalComponent } from "./dashboard/modals/save-dashboard-modal/save-dashboard-modal.component";
import { SendToSubscriptionComponent } from "./dashboard/modals/send-to-subscription/send-to-subscription.component";
import { ShareViaUrlComponent } from "./dashboard/modals/share-via-url/share-via-url.component";
import { SubscriptionModalComponent } from "./dashboard/modals/subscription-modal/subscription-modal.component";
import { TakeOwnershipComponent } from "./dashboard/modals/take-ownership/take-ownership.component";
import { TasksModalComponent } from "./dashboard/modals/tasks-modal/tasks-modal.component";
import { TemplateListModalComponent } from "./dashboard/modals/template-list-modal/template-list-modal.component";
import { ThresholdRangeValidator } from "./dashboard/modals/widget-thresholds-modal/threshold-range-validator.component";
import { WidgetThresholdsModalComponent } from "./dashboard/modals/widget-thresholds-modal/widget-thresholds-modal.component";
import { ModuleContainerComponent } from "./dashboard/module-container/module-container.component";
import { ModuleCustomSettingSectionComponent } from "./dashboard/module-custom-setting-section/module-custom-setting-section.component";
import { ModuleCxoneCustomSettingSectionDirective } from "./dashboard/module-custom-setting-section/module-cxone-custom-setting-section.directive";
import { ModuleLegacyCustomSettingSectionDirective } from "./dashboard/module-custom-setting-section/module-legacy-custom-setting-section.directive";
import { ModuleErrorComponent } from "./dashboard/module-error/module-error.component";
import { ModulePreviewComponent } from "./dashboard/module-preview/module-preview.component";
import { AgentCounterSettingsComponent } from "./dashboard/module-settings/agent-counter-settings/agent-counter-settings.component";
import { CalculatedMetricBreakdownSettingsComponent } from "./dashboard/module-settings/calculated-metric-breakdown-settings/calculated-metric-breakdown-settings.component";
import { CallArrivalSettingsComponent } from "./dashboard/module-settings/call-arrival-settings/call-arrival-settings.component";
import { ContactListSettingsComponent } from "./dashboard/module-settings/contact-list-settings/contact-list-settings.component";
import { ContactStatesSkillSettingsComponent } from "./dashboard/module-settings/contact-states-skill-settings/contact-states-skill-settings.component";
import { CurrentAgentStatesSettingsComponent } from "./dashboard/module-settings/current-agent-states-settings/current-agent-states-settings.component";
import { ExpandedSummarySettingsComponent } from "./dashboard/module-settings/expanded-summary-settings/expanded-summary-settings.component";
import { IntervalComboSettingsComponent } from "./dashboard/module-settings/interval-combo-settings/interval-combo-settings.component";
import { MetricReviewSettingsComponent } from "./dashboard/module-settings/metric-review-settings/metric-review-settings.component";
import { NgTemplateSettingsComponent } from "./dashboard/module-settings/ng-template-settings/ng-template-settings.component";
import { QueueCounterSettingsComponent } from "./dashboard/module-settings/queue-counter-settings/queue-counter-settings.component";
import { ReportingSetSettingsComponent } from "./dashboard/module-settings/reporting-set-settings/reporting-set-settings.component";
import { TopCallTimesSettingsComponent } from "./dashboard/module-settings/top-call-times-settings/top-call-times-settings.component";
import { WebhelpETSSettingsComponent } from "./dashboard/module-settings/webhelp-ets-settings/webhelp-ets-settings.component";
import { AcdCallbackComponent } from "./dashboard/modules/acd-callback/acd-callback.component";
import { AgGridIChartTemplateComponent } from "./dashboard/modules/ag-grid-ichart-template/ag-grid-ichart-template.component";
import { AgentCounterComponent } from "./dashboard/modules/agent-counter/agent-counter.component";
import { CalculatedMetricBreakdownComponent } from "./dashboard/modules/calculated-metric-breakdown/calculated-metric-breakdown.component";
import { CalculatedMetricBreakdownFormulaComponent } from "./dashboard/modules/calculated-metric-breakdown/formula-renderer/calculated-metric-breakdown-formula/calculated-metric-breakdown-formula.component";
import { CalculatorComponent } from "./dashboard/modules/calculator/calculator.component";
import { CallArrivalComponent } from "./dashboard/modules/call-arrival/call-arrival.component";
import { ContactListDetailsComponent } from "./dashboard/modules/contact-list/contact-list-details/contact-list-details.component";
import { ContactStateCellRendererComponent } from "./dashboard/modules/contact-list/contact-list-details/contact-state-cell-renderer/contact-state-cell-renderer.component";
import { ContactListImageCellRendererComponent } from "./dashboard/modules/contact-list/contact-list-image-cell-renderer/contact-list-image-cell-renderer.component";
import { ContactListComponent } from "./dashboard/modules/contact-list/contact-list.component";
import { CurrentAgentStatesPmGraphComponent } from "./dashboard/modules/current-agent-states/current-agent-states-pm/current-agent-states-pm-graph/current-agent-states-pm-graph.component";
import { CurrentAgentStatesPmTableComponent } from "./dashboard/modules/current-agent-states/current-agent-states-pm/current-agent-states-pm-table/current-agent-states-pm-table.component";
import { CurrentAgentStatesPmComponent } from "./dashboard/modules/current-agent-states/current-agent-states-pm/current-agent-states-pm.component";
import { CurrentAgentStatesComponent } from "./dashboard/modules/current-agent-states/current-agent-states.component";
import { ExpandedSummaryComponent } from "./dashboard/modules/expanded-summary/expanded-summary.component";
import { ExtendedKpiItemComponent } from "./dashboard/modules/extended-kpi-item/extended-kpi-item.component";
import { ExtendedKpiComponent } from "./dashboard/modules/extended-kpi/extended-kpi.component";
import { GaugeComponent as CVGaugeComponent } from "./dashboard/modules/gauge/gauge.component";
import { CvGameEffectivenessComponent } from "./gamification/cv-admin/components/cv-admin-games/cv-admin-games-history/cv-game-effectiveness/cv-game-effectiveness.component";
import { HeatmapComponent } from "./dashboard/modules/heatmap/heatmap.component";
import { IntervalComboComponent } from "./dashboard/modules/interval-combo/interval-combo.component";
import { KpiComponent } from "./dashboard/modules/kpi/kpi.component";
import { LeaderboardMyMetricComponent } from "./dashboard/modules/leaderboard/leaderboard-my-metric/leaderboard-my-metric.component";
import { LeaderboardRankCellRendererComponent } from "./dashboard/modules/leaderboard/leaderboard-rank-cell-renderer/leaderboard-rank-cell-renderer.component";
import { LeaderboardComponent } from "./dashboard/modules/leaderboard/leaderboard.component";
import { LinkedContactsDetailsComponent } from "./dashboard/modules/linked-contacts/linked-contacts-details/linked-contacts-details.component";
import { LinkedContactsComponent } from "./dashboard/modules/linked-contacts/linked-contacts.component";
import { LoginLogoutComponent } from "./dashboard/modules/login-logout/login-logout.component";
import { MetricReviewComponent } from "./dashboard/modules/metric-review/metric-review.component";
import { MyRankingComponent } from "./dashboard/modules/my-ranking/my-ranking.component";
import { NgTemplateComponent } from "./dashboard/modules/ng-template/ng-template.component";
import { NotepadComponent } from "./dashboard/modules/notepad/notepad.component";
import { QueueCounterComponent } from "./dashboard/modules/queue-counter/queue-counter.component";
import { ReportingSetComponent } from "./dashboard/modules/reporting-set/reporting-set.component";
import { ServiceLevelComponent } from "./dashboard/modules/service-level/service-level.component";
import { SummaryComboComponent } from "./dashboard/modules/summary-combo/summary-combo.component";
import { TasksComponent } from "./dashboard/modules/tasks/tasks.component";
import { TopCallTimesComponent } from "./dashboard/modules/top-call-times/top-call-times.component";
import { TrendingComponent } from "./dashboard/modules/trending/trending.component";
import { WebhelpETSComponent } from "./dashboard/modules/webhelp-ets/webhelp-ets.component";
import { DashboardProjectionContentComponent } from "./dashboard/projection/dashboard-projection-content/dashboard-projection-content.component";
import { ResponsiveDashboardComponent } from "./dashboard/responsive-dashboard/responsive-dashboard.component";
import { SharedDashboardComponent } from "./dashboard/shared-dashboard/shared-dashboard.component";
import { SidebarModuleListComponent } from "./dashboard/sidebar-module-list/sidebar-module-list.component";
import { TaskbarComponent } from "./dashboard/taskbar/taskbar.component";
import { ActionsCellRendererComponent } from "./dashboard/workspace/manage-available-dashboards/ag-grid-components/actions-cell-renderer/actions-cell-renderer.component";
import { CxoneDashboardNameCellRendererComponent } from "./dashboard/workspace/manage-available-dashboards/ag-grid-components/cxone-dashboard-name-cell-renderer/cxone-dashboard-name-cell-renderer.component";
import { DashboardNameRendererComponent } from "./dashboard/workspace/manage-available-dashboards/ag-grid-components/dashboard-name-renderer/dashboard-name-renderer.component";
import { DescriptionCellRendererComponent } from "./dashboard/workspace/manage-available-dashboards/ag-grid-components/description-renderer/description-renderer.component";
import { FavoriteButtonRendererComponent } from "./dashboard/workspace/manage-available-dashboards/ag-grid-components/favorite-button-renderer/favorite-button-renderer.component";
import { OwnerCellRendererComponent } from "./dashboard/workspace/manage-available-dashboards/ag-grid-components/owner-cell-renderer/owner-cell-renderer.component";
import { ShareTextRendererComponent } from "./dashboard/workspace/manage-available-dashboards/ag-grid-components/share-text-renderer/share-text-renderer/share-text-renderer.component";
import { ManageAvailableDashboardsComponent } from "./dashboard/workspace/manage-available-dashboards/manage-available-dashboards.component";
import { SelectedDashboardDetailsComponent } from "./dashboard/workspace/selected-dashboard-details/selected-dashboard-details.component";
import { CreateNewDashboardComponent } from "./dashboard/workspace/workspace-new-tab/create-new-dashboard/create-new-dashboard.component";
import { NewSystemTemplateComponent } from "./dashboard/workspace/workspace-new-tab/new-system-template/new-system-template.component";
import { OpenExistingDashboardComponent } from "./dashboard/workspace/workspace-new-tab/open-existing-dashboard/open-existing-dashboard.component";
import { OpenExistingTemplateComponent } from "./dashboard/workspace/workspace-new-tab/open-existing-template/open-existing-template.component";
import { WorkspaceNewTabLandingComponent } from "./dashboard/workspace/workspace-new-tab/workspace-new-tab-landing/workspace-new-tab-landing.component";
import { FormsAssignComponent } from "./forms/forms-assign/forms-assign.component";
import { FormsComponent } from "./forms/forms.component";
import { AwardedPopupComponent } from "./gamification/command-center/components/awards/awarded-popup/awarded-popup.component";
import { AwardsAddEditComponent } from "./gamification/command-center/components/awards/awards-add-edit/awards-add-edit.component";
import { AwardsCardMenuComponent } from "./gamification/command-center/components/awards/awards-card-menu/awards-card-menu.component";
import { AwardsLandingComponent } from "./gamification/command-center/components/awards/awards-landing/awards-landing.component";
import { GiveAwardPopupComponent } from "./gamification/command-center/components/awards/give-award-popup/give-award-popup.component";
import { AwardsExportButtonComponent } from "./gamification/command-center/components/awards/view-history/awards-export-button/awards-export-button.component";
import { AwardsHistoryListComponent } from "./gamification/command-center/components/awards/view-history/awards-history-list/awards-history-list.component";
import { BudgetExportButtonComponent } from "./gamification/command-center/components/budget/budget-history/budget-export-button/budget-export-button.component";
import { ChallengedUsersModalComponent } from "./gamification/command-center/components/challenges/challenged-users-modal/challenged-users-modal.component";
import { ChallengesHistoryComponent } from "./gamification/command-center/components/challenges/challenges-history/challenges-history.component";
import { ChallengesListComponent } from "./gamification/command-center/components/challenges/challenges-list/challenges-list.component";
import { ChallengesSettingsComponent } from "./gamification/command-center/components/challenges/challenges-settings/challenges-settings.component";
import { CurrencyPendingExportButtonComponent } from "./gamification/command-center/components/currency/currency-pending/currency-pending-export-button/currency-pending-export-button.component";
import { AddEditAssignBoxComponent } from "./gamification/command-center/components/games/games-add-edit-components/add-edit-assign-box/add-edit-assign-box.component";
import { AssignBoxPipe } from "./gamification/command-center/components/games/games-add-edit-components/add-edit-assign-box/assign-box.pipe";
import { Connect3MetricPopupComponent } from "./gamification/command-center/components/games/games-add-edit-components/connect3-metric-popup/connect3-metric-popup.component";
import { ConfigureBoardConnect3Component } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-board-connect3/configure-board-connect3.component";
import { ConfigureBoardMilestoneComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-board-milestone/configure-board-milestone.component";
import { ConfigureEligibilityBracketsComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-eligibility-brackets/configure-eligibility-brackets.component";
import { ConfigureEligibilityComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-eligibility/configure-eligibility.component";
import { ConfigureEstimatorPopupComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-estimator-popup/configure-estimator-popup.component";
import { ConfigureEstimatorComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-estimator/configure-estimator.component";
import { ConfigureFoldersComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-folders/configure-folders.component";
import { ConfigureMetricComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-metric/configure-metric.component";
import { ConfigureNameComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-name/configure-name.component";
import { ConfigureQualifierComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-qualifier/configure-qualifier.component";
import { ConfigureRewardsBracketsComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-rewards-brackets/configure-rewards-brackets.component";
import { ConfigureRewardsBullseyeComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-rewards-bullseye/configure-rewards-bullseye.component";
import { ConfigureRewardsConnect3Component } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-rewards-connect3/configure-rewards-connect3.component";
import { ConfigureRewardsMilestoneComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-rewards-milestone/configure-rewards-milestone.component";
import { ConfigureRewardsMultiplierComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-rewards-multiplier/configure-rewards-multiplier.component";
import { ConfigureRewardsRaffleComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-rewards-raffle/configure-rewards-raffle.component";
import { ConfigureRewardsTopDogComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-rewards-top-dog/configure-rewards-top-dog.component";
import { ConfigureScheduleBracketsComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-schedule-brackets/configure-schedule-brackets.component";
import { ConfigureScheduleComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-schedule/configure-schedule.component";
import { GamesConfigureComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure/games-configure.component";
import { PickGameTypeComponent } from "./gamification/command-center/components/games/games-add-edit-components/pick-game-type/pick-game-type.component";
import { GamesAddEditComponent } from "./gamification/command-center/components/games/games-add-edit/games-add-edit.component";
import { GamesDetailsComponent } from "./gamification/cv-admin/components/cv-admin-games-history/games-details/games-details.component";
import { GamesDetailsModalComponent } from "./gamification/command-center/components/games/games-details-modal/games-details-modal.component";
import { GameHistoryBreakdownEffectivenessComponent } from "./gamification/command-center/components/games/games-history-health-components/game-history-breakdown-effectiveness/game-history-breakdown-effectiveness.component";
import { HealthReportExportButtonComponent } from "./gamification/command-center/components/games/games-history-health-components/health-report-export-button/health-report-export-button.component";
import { HealthReportSpecificDetailsComponent } from "./gamification/command-center/components/games/games-history-health-components/health-report-specific-details/health-report-specific-details.component";
import { HealthReportTopPerformersComponent } from "./gamification/command-center/components/games/games-history-health-components/health-report-top-performers/health-report-top-performers.component";
import { GamesHistoryHealthReportComponent } from "./gamification/command-center/components/games/games-history-health-report/games-history-health-report.component";
import { GamesHistoryComponent } from "./gamification/command-center/components/games/games-history/games-history.component";
import { GamesLandingComponent } from "./gamification/command-center/components/games/games-landing/games-landing.component";
import { MilestoneBadgesRendererComponent } from "./gamification/command-center/components/games/renderers/milestone-badges-renderer/milestone-badges-renderer.component";
import { MilestoneResultsRendererComponent } from "./gamification/command-center/components/games/renderers/milestone-results-renderer/milestone-results-renderer.component";
import { RevertPayoutDetailsComponent } from "./gamification/command-center/components/games/revert-payout-details/revert-payout-details.component";
import { AwardsFilterPipe } from "./gamification/command-center/custom-pipes/award-name-filter.pipe";
import { GamificationExportComponent } from "./gamification/gamification-export/gamification-export.component";
import { CxoneSentimentCellRendererComponent } from "./reusables/cxone-sentiment-cell-renderer/cxone-sentiment-cell-renderer.component";
import { GenericDowSelectorComponent } from "./reusables/generic-dow-selector/generic-dow-selector.component";
import { ObjectivesDetailsComponent } from "./reusables/objectives-details/objectives-details.component";
import { SentimentLegendComponent } from "./reusables/sentiment-legend/sentiment-legend.component";
// import { RewardDetailsComponent } from './gamification/command-center/components/games/reward-details/reward-details.component';
import { FloatingMenuModule as ButtonMenuSolModule } from "@niceltd/sol/floating-menu";
import { ProgressBarModule } from "@niceltd/sol/progress-bar";
import { QueryBuilderModule } from "@niceltd/sol/query-builder";
import {
    localeInitializerProvider,
    TranslationService,
} from "@niceltd/sol/translation";
import { UserIdleService } from "angular-user-idle";
import { DialogService, DynamicDialogModule } from "primeng/dynamicdialog";
import { SubscriptionManagementEditComponent } from "src/app/admin/Subscription/subscription-management-edit/subscription-management-edit.component";
import { SubscriptionManagementComponent } from "src/app/admin/Subscription/subscription-management/subscription-management.component";
import { CvPointStoreProductSettingCxoneComponent } from "src/app/gamification/cv-marketplace-admin/components/cv-point-store-product-setting-cxone/cv-point-store-product-setting-cxone.component";
import { LaunchWallboardPreviewComponent } from "./admin/launch-wallboard/launch-wallboard-preview/launch-wallboard-preview.component";
import { BattleBoatChallengeComponent } from "./dashboard/challenges/battleboat/battle-boat-challenge/battle-boat-challenge.component";
import { BattleBoatDetailsComponent } from "./dashboard/challenges/battleboat/battle-boat-details/battle-boat-details.component";
import { BattleBoatShotComponent } from "./dashboard/challenges/battleboat/battle-boat-shot/battle-boat-shot.component";
import { BoardShipsComponent } from "./dashboard/challenges/battleboat/board-ships/board-ships.component";
import { BoardComponent } from "./dashboard/challenges/battleboat/board/board.component";
import { ChallengeBattleBoatResultComponent } from "./dashboard/challenges/battleboat/challenge-result/challenge-result.component";
import { ShadowBoxingResultComponent } from "./dashboard/challenges/shadow-boxing-result/shadow-boxing-result.component";
import { ShadowBoxingPreviewComponent } from "./dashboard/challenges/shadow-boxing/shadow-boxing-preview/shadow-boxing-preview.component";
import { ShadowBoxingProgressComponent } from "./dashboard/challenges/shadow-boxing/shadow-boxing-progress/shadow-boxing-progress.component";
import { ChallengeCardViewComponent } from "./dashboard/challenges/shared/challenge-card-view/challenge-card-view.component";
import { CreateReportSubscriptionComponent } from "./dashboard/create-report-subscription/create-report-subscription.component";

import { AgentStateDetailCXOneComponent } from "./dashboard/modals/agent-state-detail-cxone/agent-state-detail-cxone.component";
import { SuggestCoachingModalComponent } from "./dashboard/modals/suggest-coaching-modal/suggest-coaching-modal.component";
import { UserIdleComponent } from "./dashboard/modals/user-idle/user-idle.component";
import { ModuleLegacySettingsModalComponent } from "./dashboard/module-legacy-settings-modal/module-legacy-settings-modal.component";
import { ScheduleAdherenceSettingsComponent } from "./dashboard/module-settings/schedule-adherence-settings/schedule-adherence-settings.component";
import { ModuleSubscriptionSettingsContainerComponent } from "./dashboard/module-subscription-settings-container/module-subscription-settings-container.component";
import { BANCOITAUComponent } from "./dashboard/modules/banco-itau/banco-itau.component";
import { CoachingEffectivenessComponent } from "./dashboard/modules/coaching-effectiveness/coaching-effectiveness.component";
import { AgentStateCellRendererComponent } from "./dashboard/modules/current-agent-states/agent-state-cell-renderer/agent-state-cell-renderer.component";
import { CurrentHoldTimesPmComponent } from "./dashboard/modules/current-hold-times/current-hold-times-pm/current-hold-times-pm.component";
import { CurrentHoldTimesComponent } from "./dashboard/modules/current-hold-times/current-hold-times.component";
import { DispositionsComponent } from "./dashboard/modules/dispositions/dispositions.component";
import { ExpandedSummaryCxoneComponent } from "./dashboard/modules/expanded-summary/expanded-summary-cxone/expanded-summary-cxone.component";
import { ExpandedSummaryPmComponent } from "./dashboard/modules/expanded-summary/expanded-summary-pm/expanded-summary-pm.component";
import { ScheduleAdherenceComponent } from "./dashboard/modules/schedule-adherence/schedule-adherence.component";
import { PublishBarComponent } from "./dashboard/publish-bar/publish-bar.component";
import { WorkspaceLandingComponent } from "./dashboard/workspace/workspace-landing/workspace-landing.component";
import { CvAwardHistoryModalCellRendererComponent } from "./gamification/command-center/components/awards/cv-award-history-modal-cell-renderer/cv-award-history-modal-cell-renderer.component";
import { CvAwardHistoryModalComponent } from "./gamification/command-center/components/awards/cv-award-history-modal/cv-award-history-modal.component";
import { CxoneChallengesLeadCellRendererComponent } from "./gamification/command-center/components/challenges/challenges-list/cxone-challenges-lead-renderer/cxone-challenges-lead-renderer.component";
import { BracketViewComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/configure-eligibility-brackets/bracket-view/bracket-view.component";
import { ScheduleAdvancedOptionsComponent } from "./gamification/command-center/components/games/games-add-edit-components/games-configure-components/schedule-advanced-options/schedule-advanced-options.component";
import { RaffleRewardsDetailsComponent } from "./gamification/command-center/components/games/games-add-edit-components/raffle-rewards-details/raffle-rewards-details.component";
import { GamesHistoryExportButtonComponent } from "./gamification/command-center/components/games/games-history-export-button/games-history-export-button.component";
import { GamesHistoryTableComponent } from "./gamification/command-center/components/games/tables/games-history-table/games-history-table.component";
import { RewardEstimatorTableComponent } from "./gamification/command-center/components/games/tables/reward-estimator-table/reward-estimator-table.component";
import { TeamsHistoryTableComponent } from "./gamification/command-center/components/games/tables/teams-history-table/teams-history-table.component";
import { CommandCenterGroupSelectorComponent } from "./gamification/command-center/components/overview/command-center-group-selector/command-center-group-selector.component";
import { CommandCenterComponent } from "./gamification/command-center/components/overview/command-center/command-center.component";
import { CommandCenterOnboardingComponent } from "./gamification/command-center/components/overview/modals/command-center-onboarding/command-center-onboarding.component";
import { GamesRunningModalComponent } from "./gamification/command-center/components/overview/modals/games-running-modal/games-running-modal.component";
import { MarketplaceOrdersModalComponent } from "./gamification/command-center/components/overview/modals/marketplace-orders-modal/marketplace-orders-modal.component";
import { MarketplaceOrdersTableComponent } from "./gamification/command-center/components/overview/modals/marketplace-orders-table/marketplace-orders-table.component";
import { MarketplaceProductsModalComponent } from "./gamification/command-center/components/overview/modals/marketplace-products-modal/marketplace-products-modal.component";
import { BadgesEarnedComponent } from "./gamification/command-center/components/overview/modules/badges-earned/badges-earned.component";
import { CoinHistoryComponent } from "./gamification/command-center/components/overview/modules/coin-history/coin-history.component";
import { CoinsEarnedComponent } from "./gamification/command-center/components/overview/modules/coins-earned/coins-earned.component";
import { GamesRunningByTypeComponent } from "./gamification/command-center/components/overview/modules/games-running-by-type/games-running-by-type.component";
import { MarketplaceOverviewComponent } from "./gamification/command-center/components/overview/modules/marketplace-overview/marketplace-overview.component";
import { CustomMetricFormatterPipe } from "./gamification/command-center/custom-pipes/custom-metric-formatter.pipe";
import { GamesFilterPipe } from "./gamification/command-center/custom-pipes/games-filter.pipe";
import { CvAdminAwardsComponent } from "./gamification/cv-admin/components/cv-admin-awards/cv-admin-awards.component";
import { CvAdminBudgetHistoryComponent } from "./gamification/cv-admin/components/cv-admin-budget-history/cv-admin-budget-history.component";
import { CvAdminBudgetMeterComponent } from "./gamification/cv-admin/components/cv-admin-budget-meter/cv-admin-budget-meter.component";
import { CvAdminBudgetNotificationsComponent } from "./gamification/cv-admin/components/cv-admin-budget-notifications/cv-admin-budget-notifications.component";
import { CvAdminBudgetSetupComponent } from "./gamification/cv-admin/components/cv-admin-budget-setup/cv-admin-budget-setup.component";
import { CvAdminBudgetTitleHeaderComponent } from "./gamification/cv-admin/components/cv-admin-budget-title-header/cv-admin-budget-title-header.component";
import { CvAdminBudgetComponent } from "./gamification/cv-admin/components/cv-admin-budget/cv-admin-budget.component";
import { CvAdminChallengeComponent } from "./gamification/cv-admin/components/cv-admin-challenge/cv-admin-challenge.component";
import { CvAdminGamesComponent } from "./gamification/cv-admin/components/cv-admin-games/cv-admin-games.component";
import { CvAdminGameHistorySpecificDetailsComponent } from './gamification/cv-admin/components/cv-admin-games/cv-admin-games-history/cv-admin-game-history-specific-details/cv-admin-game-history-specific-details.component';
import { CvAdminLandingComponent } from "./gamification/cv-admin/components/cv-admin-landing/cv-admin-landing.component";
import { CvPointStoreNewEditProductComponent } from "./gamification/cv-marketplace-admin/components/cv-point-store-new-edit-product/cv-point-store-new-edit-product.component";
import { CvPointStoreProductAssignmentCxoneComponent } from "./gamification/cv-marketplace-admin/components/cv-point-store-product-assignment-cxone/cv-point-store-product-assignment-cxone.component";
import { CvPointStoreProductInformationCxoneComponent } from "./gamification/cv-marketplace-admin/components/cv-point-store-product-information-cxone/cv-point-store-product-information-cxone.component";
import { CvPointStoreProductSummaryCxoneComponent } from "./gamification/cv-marketplace-admin/components/cv-point-store-product-summary-cxone/cv-point-store-product-summary-cxone.component";
import { CvPointStoreProductUploadCxoneComponent } from "./gamification/cv-marketplace-admin/components/cv-point-store-product-upload-cxone/cv-point-store-product-upload-cxone.component";
import { CxoneOrderManagementGridLoaderComponent } from "./gamification/cv-marketplace-admin/components/cxone-custom-grid-components/cxone-order-management-grid-loader/cxone-order-management-grid-loader.component";
import { CxoneOrderManagementGridProductComponent } from "./gamification/cv-marketplace-admin/components/cxone-custom-grid-components/cxone-order-management-grid-product/cxone-order-management-grid-product.component";
import { CxoneOrderManagementGridTextContainerComponent } from "./gamification/cv-marketplace-admin/components/cxone-custom-grid-components/cxone-order-management-grid-text-container/cxone-order-management-grid-text-container.component";
import { CxoneOrderManagementNotesModalComponent } from "./gamification/cv-marketplace-admin/components/cxone-custom-grid-components/cxone-order-management-notes-modal/cxone-order-management-notes-modal.component";
import { CxoneOrderManagementNotesTooltipComponent } from "./gamification/cv-marketplace-admin/components/cxone-custom-grid-components/cxone-order-management-notes-tooltip/cxone-order-management-notes-tooltip.component";
import { CxoneOrderManagementGridComponent } from "./gamification/cv-marketplace-admin/components/cxone-order-management-grid/cxone-order-management-grid.component";
import { CxoneOrderManagementComponent } from "./gamification/cv-marketplace-admin/components/cxone-order-management/cxone-order-management.component";
import { FilesizeformatPipe } from "./gamification/cv-marketplace-admin/pipes/filesizeformat.pipe";
import { CvMarketplaceCartDrawerComponent } from "./gamification/cv-marketplace/components/cv-marketplace-cart-drawer/cv-marketplace-cart-drawer.component";
import { CvMarketplaceFilterComponent } from "./gamification/cv-marketplace/components/cv-marketplace-filter/cv-marketplace-filter.component";
import { CvMarketplaceShoppingCartCarouselComponent } from "./gamification/cv-marketplace/components/cv-marketplace-shopping-cart-carousel/cv-marketplace-shopping-cart-carousel.component";
import { CvMarketplaceShoppingCartCategoriesLandingComponent } from "./gamification/cv-marketplace/components/cv-marketplace-shopping-cart-categories-landing/cv-marketplace-shopping-cart-categories-landing.component";
import { CvMarketplaceShoppingCartFeaturedComponent } from "./gamification/cv-marketplace/components/cv-marketplace-shopping-cart-featured/cv-marketplace-shopping-cart-featured.component";
import { CvMarketplaceShoppingCartHomeComponent } from "./gamification/cv-marketplace/components/cv-marketplace-shopping-cart-home/cv-marketplace-shopping-cart-home.component";
import { CvMarketplaceShoppingCartOrdersComponent } from "./gamification/cv-marketplace/components/cv-marketplace-shopping-cart-orders/cv-marketplace-shopping-cart-orders.component";
import { CvMarketplaceShoppingCartProductDetailsComponent } from "./gamification/cv-marketplace/components/cv-marketplace-shopping-cart-product-details/cv-marketplace-shopping-cart-product-details.component";
import { CvMarketplaceShoppingCartWishlistComponent } from "./gamification/cv-marketplace/components/cv-marketplace-shopping-cart-wishlist/cv-marketplace-shopping-cart-wishlist.component";
import { CvMarketplaceShoppingCartComponent } from "./gamification/cv-marketplace/components/cv-marketplace-shopping-cart/cv-marketplace-shopping-cart.component";
import { CxoneOrderPlacedComponent } from "./gamification/cv-marketplace/cxone-components/cxone-order-placed/cxone-order-placed.component";
import { CvMarketplaceProductsFilterPipe } from "./gamification/cv-marketplace/pipes/cv-marketplace-products-filter.pipe";
import { MarketplaceOrdersTableComponentComponent } from "./gamification/marketplace/admin/components/marketplace-orders-table-component/marketplace-orders-table-component.component";
import { PointStoreAssignGroupAttrComponent } from "./gamification/marketplace/admin/components/point-store-assign-group-attr/point-store-assign-group-attr.component";
import { PointStoreCxoneSidebarComponent } from "./gamification/marketplace/admin/components/point-store-cxone-sidebar/point-store-cxone-sidebar.component";
import { PointStoreEditComponent } from "./gamification/marketplace/admin/components/point-store-edit/point-store-edit.component";
import { PointStoreNavigationBarComponent } from "./gamification/marketplace/admin/components/point-store-navigation-bar/point-store-navigation-bar.component";
import { PointStoreOrdersAdminComponent } from "./gamification/marketplace/admin/components/point-store-orders-admin/point-store-orders-admin.component";
import { PointStoreProductAssignmentComponent } from "./gamification/marketplace/admin/components/point-store-product-assignment/point-store-product-assignment.component";
import { PointStoreProductGroupSelectorComponent } from "./gamification/marketplace/admin/components/point-store-product-group-selector/point-store-product-group-selector.component";
import { PointStoreProductInformationComponent } from "./gamification/marketplace/admin/components/point-store-product-information/point-store-product-information.component";
import { PointStoreProductLandingCardCvComponent } from "./gamification/marketplace/admin/components/point-store-product-landing-card-cv/point-store-product-landing-card-cv.component";
import { PointStoreProductLandingCardComponent } from "./gamification/marketplace/admin/components/point-store-product-landing-card/point-store-product-landing-card.component";
import { PointStoreProductLandingListComponent } from "./gamification/marketplace/admin/components/point-store-product-landing-list/point-store-product-landing-list.component";
import { PointStoreProductLandingPageComponent } from "./gamification/marketplace/admin/components/point-store-product-landing-page/point-store-product-landing-page.component";
import { PointStoreProductLandingThumbnailComponent } from "./gamification/marketplace/admin/components/point-store-product-landing-thumbnail/point-store-product-landing-thumbnail.component";
import { PointStoreProductSettingComponent } from "./gamification/marketplace/admin/components/point-store-product-setting/point-store-product-setting.component";
import { PointStoreProductSummaryComponent } from "./gamification/marketplace/admin/components/point-store-product-summary/point-store-product-summary.component";
import { PointStoreProductUploadComponent } from "./gamification/marketplace/admin/components/point-store-product-upload/point-store-product-upload.component";
import { FilterPipe } from "./gamification/marketplace/admin/custom-pipes/filter.pipe";
import { GroupByPipe } from "./gamification/marketplace/admin/custom-pipes/group-by.pipe";
import { ProductsFilterPipe } from "./gamification/marketplace/admin/custom-pipes/products-filter.pipe";
import { UniquePipe } from "./gamification/marketplace/admin/custom-pipes/unique.pipe";
import { AgentOrderHistoryComponent } from "./gamification/marketplace/agent-side/components/agent-order-history/agent-order-history.component";
import { ShoppingCartLandingComponent } from "./gamification/marketplace/agent-side/components/shopping-cart-landing/shopping-cart-landing.component";
import { ShoppingCartListComponent } from "./gamification/marketplace/agent-side/components/shopping-cart-list/shopping-cart-list.component";
import { ListFilterPipe } from "./gamification/marketplace/agent-side/custom-pipes/list-filter.pipe";
import { DeleteBtnRenderedComponent } from "./gamification/marketplace/agent-side/custom-renders/delete-btn-rendered/delete-btn-rendered.component";
import { FooterButtonRenderedComponent } from "./gamification/marketplace/agent-side/custom-renders/footer-button-rendered/footer-button-rendered.component";
import { FooterEmptyRenderedComponent } from "./gamification/marketplace/agent-side/custom-renders/footer-empty-rendered/footer-empty-rendered.component";
import { FooterSubtotalRenderedComponent } from "./gamification/marketplace/agent-side/custom-renders/footer-subtotal-rendered/footer-subtotal-rendered.component";
import { QtyInputRenderedComponent } from "./gamification/marketplace/agent-side/custom-renders/qty-input-rendered/qty-input-rendered.component";
import { ReorderBtnRenderedComponent } from "./gamification/marketplace/agent-side/custom-renders/reorder-btn-rendered/reorder-btn-rendered.component";
import { SubtotalRenderedComponent } from "./gamification/marketplace/agent-side/custom-renders/subtotal-rendered/subtotal-rendered.component";
import { PageErrorStateComponent } from "./gamification/page-error-state/page-error-state.component";
import { WINDOW_INJECTION_TOKEN } from "./injection-tokens";
import { NavigationHeaderMenuComponent } from "./navigation/navigation-header/navigation-header-menu/navigation-header-menu.component";
import { SubmitFeedbackComponent } from "./navigation/navigation-header/submit-feedback/submit-feedback.component";
import { NgxCleaveDirective } from "./ngx-cleave-directive-cv-custom/ngx-cleave-directive-cv-custom.component";
import { ReleaseModalComponent } from "./notifications/release-modal/release-modal.component";
import { CategorizeMetricDefinitions } from "./pipeline-config/categorize-metric-definitions.pipe";
import { EditMetricComponent } from "./pipeline-config/edit-metric/edit-metric.component";
import { IntegrationMongoLogsCellRendererComponent } from "./pipeline-config/integration-mongo-logs/integration-mongo-logs-cell-renderer/integration-mongo-logs-cell-renderer.component";
import { IntegrationMongoLogsComponent } from "./pipeline-config/integration-mongo-logs/integration-mongo-logs.component";
import { MetricComponentModalComponent } from "./pipeline-config/metric-component-modal/metric-component-modal.component";
import { MetricComponentPreviewComponent } from "./pipeline-config/metric-component-preview/metric-component-preview.component";
import { MetricDefinitionsLandingComponent } from "./pipeline-config/metric-definitions-landing/metric-definitions-landing.component";
import { MetricFormulaComponent } from "./pipeline-config/metric-formula/metric-formula.component";
import { MetricSummaryComponent } from "./pipeline-config/metric-summary/metric-summary.component";
import { AddCustomHierarchyComponent } from "./pipeline/hierarchy/add-custom-hierarchy/add-custom-hierarchy.component";
import { RecordingsDetailsComponent } from "./recordings/recordings-details/recordings-details.component";
import { RecordingsLandingComponent } from "./recordings/recordings-landing/recordings-landing.component";
import { ManageReportsComponent } from "./reports/manage-reports/manage-reports.component";
import { SysTemplateActionCellRendererComponent } from "./reports/manage-reports/systemplate-action-cell-renderer/systemplate-action-cell-renderer.component";
import { SystemplateCellRendererComponent } from "./reports/manage-reports/systemplate-cell-renderer/systemplate-cell-renderer.component";
import { SystemplateStatusCellRendererComponent } from "./reports/manage-reports/systemplate-status-cell-renderer/systemplate-status-cell-renderer/systemplate-status-cell-renderer.component";
import { CvAngularLoadingOverlayComponent } from "./reusables/ag-grid-components/cv-angular-loading-overlay/cv-angular-loading-overlay.component";
import { CxoneCheckboxCellComponent } from "./reusables/ag-grid-components/cxone-checkbox-cell/cxone-checkbox-cell.component";
import { CxoneCheckboxHeaderComponent } from "./reusables/ag-grid-components/cxone-checkbox-header/cxone-checkbox-header.component";
import { CxoneHighlightSearchCellRendererComponent } from "./reusables/ag-grid-components/cxone-highlight-search-cell-renderer/cxone-highlight-search-cell-renderer.component";
import { CxoneTruncateTextCellRendererComponent } from "./reusables/ag-grid-components/cxone-truncate-text-cell-renderer/cxone-truncate-text-cell-renderer.component";
import { AngularAssignToolComponent } from "./reusables/assign-tool/angular-assign-tool/angular-assign-tool.component";
import { CvConnect3AllResultRenderComponent } from './gamification/command-center/components/games/tables/cv-connect3-all-result-render/cv-connect3-all-result-render.component';
import { CxoneLoginsAssignToolComponent } from "./reusables/assign-tool/cxone-logins-assign-tool/cxone-logins-assign-tool.component";
import { DashboardAssignmentPermissionsRendererComponent } from "./reusables/assign-tool/dashboard-assignment/dashboard-assignment-permissions-renderer/dashboard-assignment-permissions-renderer.component";
import { DashboardAssignmentComponent } from "./reusables/assign-tool/dashboard-assignment/dashboard-assignment.component";
import { MetricDefinitionAssignmentComponent } from "./reusables/assign-tool/metric-definition-assignment/metric-definition-assignment.component";
import { AttributeSelectorComponent } from "./reusables/attribute-selector/attribute-selector.component";
import { BadgeSelectorComponent } from "./reusables/badge-selector/badge-selector.component";
import { BaremetricsCalendarComponent } from "./reusables/baremetrics-calendar/baremetrics-calendar.component";
import { BroadcastAssignComponent } from "./reusables/broadcasts/broadcast-assign/broadcast-assign.component";
import { BroadcastDetailsComponent } from "./reusables/broadcasts/broadcast-details/broadcast-details.component";
import { ConfirmDialogComponent } from "./reusables/confirm-dialog/confirm-dialog.component";
import { CustomBadgeCreatorComponent } from "./reusables/custom-badge-creator/custom-badge-creator.component";
import { CustomDialogComponent } from "./reusables/custom-dialog/custom-dialog.component";
import { CvLoaderComponent } from "./reusables/cv-loader/cv-loader.component";
import { CvLocalizedAttrsDirective } from "./reusables/cv-localized-attrs.directive";
import { CxoneRangeSliderComponent } from "./reusables/cxone-range-slider/cxone-range-slider.component";
import { DateRangeSelectorComponent } from "./reusables/date-range-selector/date-range-selector.component";
import { DowSelectorComponent } from "./reusables/dow-selector/dow-selector.component";
import { FormDisplayComponent } from "./reusables/form-display/form-display.component";
import { GeneralWallboardSettingsSelectorComponent } from "./reusables/general-wallboard-settings-selector/general-wallboard-settings-selector.component";
import { GridTemplateComponent } from "./reusables/grid-template/grid-template.component";
import { GroupSelectorComponent } from "./reusables/group-selector/group-selector.component";
import { GroupViewBySelectorComponent } from "./reusables/group-view-by-selector/group-view-by-selector.component";
import { ImageFallbackDirective } from "./reusables/image-fallback/image-fallback.directive";
import { ImgCropComponent } from "./reusables/img-crop/img-crop.component";
import { AutoFocusDirective } from "./reusables/input-auto-focus/input-auto-focus.directive";
import { InputNumericFormatDirective } from "./reusables/input-numeric-format/input-numeric-format.directive";
import { InteractiveBarComponent } from "./reusables/interactive-bar/interactive-bar.component";
import { IntervalSelectorComponent } from "./reusables/interval-selector/interval-selector.component";
import { CvLocalizedPlaceholderDirective } from "./reusables/localization/cv-localized-placeholder.directive";
import { MetricSelectorComponent } from "./reusables/metric-selector/metric-selector.component";
import { MultiSelectComponent } from "./reusables/multi-select/multi-select.component";
import { NavigationSidebarClassDirective } from "./reusables/navigation-sidebar-class/navigation-sidebar-class.directive";
import { NgModelChangeDebouncedDirective } from "./reusables/ng-model-change-debounced/ng-model-change-debounced.directive";
import { ArraySortPipe } from "./reusables/pipes/array-sort.pipe";
import { BoldTextPipe } from "./reusables/pipes/bold-text.pipe";
import { CleanIdPipe } from "./reusables/pipes/clean-id.pipe";
import { CvNumberLocalizePipe } from "./reusables/pipes/cv-number-localize.pipe";
import { CvOrdinalLocalizePipe } from "./reusables/pipes/cv-ordinal-localize.pipe";
import { EncodeColorPipe } from "./reusables/pipes/encode-color.pipe";
import { FilterTextPipe } from "./reusables/pipes/filter-text.pipe";
import { FormatNumericTypePipe } from "./reusables/pipes/format-numeric-type.pipe";
import { GenericMetricFormatterPipe } from "./reusables/pipes/generic-metric-formatter.pipe";
import { LimitToPipe } from "./reusables/pipes/limit-to.pipe";
import { NumberLocalizePipe } from "./reusables/pipes/number-localize.pipe";
import { OrderByPipe } from "./reusables/pipes/order-by.pipe";
import { SafeUrlPipe } from "./reusables/pipes/safe-url.pipe";
import { StartOnPipe } from "./reusables/pipes/start-on.pipe";
import { PreventMenuCloseDirective } from "./reusables/prevent-menu-close/prevent-menu-close.directive";
import { ProfilePictureApprovalComponent } from "./reusables/profile-picture-approval/profile-picture-approval.component";
import { QuickDateRangeSelectorComponent } from "./reusables/quick-date-range-selector/quick-date-range-selector.component";
import { ResetConfirmDialogComponent } from "./reusables/reset-confirm-dialog/reset-confirm-dialog.component";
import { CVApiService } from "./reusables/services/cv-api.service";
import { SettingsSlideoutComponent } from "./reusables/settings-slideout/settings-slideout.component";
import { SingleAttributeSelectorComponent } from "./reusables/single-attribute-selector/single-attribute-selector.component";
import { SingleSelectComponent } from "./reusables/single-select/single-select.component";
import { SolRangeSliderWrapperComponent } from "./reusables/sol-range-slider-wrapper/sol-range-slider-wrapper.component";
import { SubscriptionSchedulerComponent } from "./reusables/subscription-scheduler/subscription-scheduler.component";
import { TimeEntryDirective } from "./reusables/time-entry/time-entry.directive";
import { TimePickerComponent } from "./reusables/time-picker/time-picker.component";
import { TimeRangeSelectorComponent } from "./reusables/time-range-selector/time-range-selector.component";
import { TimeSliderComponent } from "./reusables/time-slider/time-slider.component";
import { WallboardColumnSortSelectorComponent } from "./reusables/wallboard-column-sort-selector/wallboard-column-sort-selector.component";
import { WarningDialogComponent } from "./reusables/warning-dialog/warning-dialog.component";
import { WallboardViewChallengesComponent } from "./wallboards/wallboardView/wallboard-view-challenges/wallboard-view-challenges.component";
import { WallboardViewCurrentAgentStatesResponsiveComponent } from "./wallboards/wallboardView/wallboard-view-current-agent-states-responsive/wallboard-view-current-agent-states-responsive.component";
import { WallboardViewCurrentAgentStatesComponent } from "./wallboards/wallboardView/wallboard-view-current-agent-states/wallboard-view-current-agent-states.component";
import { WallboardViewCustomAchievementComponent } from "./wallboards/wallboardView/wallboard-view-custom-achievement/wallboard-view-custom-achievement.component";
import { WallboardViewCustomAgentCounterComponent } from "./wallboards/wallboardView/wallboard-view-custom-agent-counter/wallboard-view-custom-agent-counter.component";
import { WallboardViewCustomGaugeComponent } from "./wallboards/wallboardView/wallboard-view-custom-gauge/wallboard-view-custom-gauge.component";
import { WallboardViewCustomImageComponent } from "./wallboards/wallboardView/wallboard-view-custom-image/wallboard-view-custom-image.component";
import { WallboardViewCustomKpiComponent } from "./wallboards/wallboardView/wallboard-view-custom-kpi/wallboard-view-custom-kpi.component";
import { WallboardViewCustomSummaryComponent } from "./wallboards/wallboardView/wallboard-view-custom-summary/wallboard-view-custom-summary.component";
import { WallboardViewCustomTextComponent } from "./wallboards/wallboardView/wallboard-view-custom-text/wallboard-view-custom-text.component";
import { WallboardViewCustomThermometerComponent } from "./wallboards/wallboardView/wallboard-view-custom-thermometer/wallboard-view-custom-thermometer.component";
import { WallboardViewCustomTopComponent } from "./wallboards/wallboardView/wallboard-view-custom-top/wallboard-view-custom-top.component";
import { WallboardViewCustomComponent } from "./wallboards/wallboardView/wallboard-view-custom/wallboard-view-custom.component";
import { WallboardViewErrorComponent } from "./wallboards/wallboardView/wallboard-view-error/wallboard-view-error.component";
import { WallboardViewGamesComponent } from "./wallboards/wallboardView/wallboard-view-games/wallboard-view-games.component";
import { WallboardViewImageComponent } from "./wallboards/wallboardView/wallboard-view-image/wallboard-view-image.component";
import { WallboardViewLeaderboardComponent } from "./wallboards/wallboardView/wallboard-view-leaderboard/wallboard-view-leaderboard.component";
import { WallboardViewMainComponent } from "./wallboards/wallboardView/wallboard-view-main/wallboard-view-main.component";
import { WallboardViewMarketplaceComponent } from "./wallboards/wallboardView/wallboard-view-marketplace/wallboard-view-marketplace.component";
import { WallboardViewRacingComponent } from "./wallboards/wallboardView/wallboard-view-racing/wallboard-view-racing.component";
import { WallboardViewScorecardComponent } from "./wallboards/wallboardView/wallboard-view-scorecard/wallboard-view-scorecard.component";
import { WallboardViewSpotlightComponent } from "./wallboards/wallboardView/wallboard-view-spotlight/wallboard-view-spotlight.component";
import { WallboardViewSummaryComponent } from "./wallboards/wallboardView/wallboard-view-summary/wallboard-view-summary.component";
import { WallboardViewVideoComponent } from "./wallboards/wallboardView/wallboard-view-video/wallboard-view-video.component";
import { WallboardsAssignComponent } from "./wallboards/wallboards-assign.component";
import { WallboardsComponent } from "./wallboards/wallboards.component";
import { WorkAidsNewComponent } from "./work-aids/work-aids-new/work-aids-new.component";
import { WorkAidsComponent } from "./work-aids/work-aids.component";

import localeDe from "@angular/common/locales/de";
import localeEs from "@angular/common/locales/es";
import localeFr from "@angular/common/locales/fr";
import localeJa from "@angular/common/locales/ja";
import localeKo from "@angular/common/locales/ko";
import localeNl from "@angular/common/locales/nl";
import localePt from "@angular/common/locales/pt";
import localeSv from "@angular/common/locales/sv";
import localeZh from "@angular/common/locales/zh";

export const AppInitializerFactory =
    (
        i18next: ITranslationService,
        locationInitializer: LocalizationInitializer,
        config: ConfigurationCoreService,
        cvApiService: CVApiService
    ) =>
        async () => {
            // If there is a token URL to pull from
            if (window["navigationData"]?.CXOneTokenUrls != null) {
                const cxoneTokenUrls = window["navigationData"].CXOneTokenUrls;
                config.setConfigurationData({
                    languageMetaDataPath: `${cxoneTokenUrls.niceBaseUrl}/apps`,
                    apiServerBaseUrl: cxoneTokenUrls.niceBaseUrl,
                });
                await locationInitializer.load();
            } else {
                const solEnglishDefault = await cvApiService.get(
                    "/dist/angular/assets/strings/components/sol-components/strings_en_US.json"
                );

                const languageDetector: LanguageDetectorModule = {
                    type: "languageDetector",
                    detect: () => "en-US",
                    init: (_) => { },
                    cacheUserLanguage: (_) => { },
                };

                const initOptions: InitOptions = {
                    fallbackLng: "en",
                    defaultNS: "ns",
                    ns: ["ns"],
                    resources: {
                        en: {
                            ns: {
                                ...solEnglishDefault,
                            },
                        },
                    },
                };

                await i18next.use(languageDetector).init(initOptions);
            }

            // Add languages that are supported from the browser for Angular to map to.
            registerLocaleData(localeFr, "fr");
            registerLocaleData(localeDe, "de");
            registerLocaleData(localeEs, "es");
            registerLocaleData(localePt, "pt");
            registerLocaleData(localeJa, "ja");
            registerLocaleData(localeKo, "ko");
            registerLocaleData(localeNl, "nl");
            registerLocaleData(localeZh, "zh");
            registerLocaleData(localeSv, "sv");
        };

@NgModule({
    declarations: [
        AboutComponent,
        AccessUseradminComponent,
        AcdCallbackComponent,
        ActionsCellRendererComponent,
        AddCustomHierarchyComponent,
        AddEditAssignBoxComponent,
        AddUserComponent,
        AgentCounterComponent,
        AgentCounterSettingsComponent,
        AgentOrderHistoryComponent,
        AgentStateCellRendererComponent,
        AgentStateDetailComponent,
        AgentStateDetailCXOneComponent,
        AgentStatesColorModalComponent,
        AgGridGroupHeaderTooltipComponent,
        AgGridIChartTemplateComponent,
        AngularAssignToolComponent,
        AnnouncementsComponent,
        AnnouncementsNewComponent,
        ArraySortPipe,
        AssignBoxPipe,
        AttributeSelectorComponent,
        AttributesUseradminComponent,
        AutoFocusDirective,
        AwardCardComponent,
        AwardedPopupComponent,
        AwardsAddEditComponent,
        AwardsCardMenuComponent,
        AwardsExportButtonComponent,
        AwardsFilterPipe,
        AwardsHistoryListComponent,
        AwardsLandingComponent,
        BadgesEarnedComponent,
        BadgeSelectorComponent,
        BANCOITAUComponent,
        BaremetricsCalendarComponent,
        BattleBoatChallengeComponent,
        BattleBoatDetailsComponent,
        BattleBoatShotComponent,
        BoardComponent,
        BoardShipsComponent,
        BoldTextPipe,
        BracketViewComponent,
        BroadcastAssignComponent,
        BroadcastDetailsComponent,
        BudgetExportButtonComponent,
        CalculatedMetricBreakdownComponent,
        CalculatedMetricBreakdownFormulaComponent,
        CalculatedMetricBreakdownSettingsComponent,
        CalculatorComponent,
        CallArrivalComponent,
        CallArrivalSettingsComponent,
        CategorizeMetricDefinitions,
        ChallengeBattleBoatResultComponent,
        ChallengeCardViewComponent,
        ChallengedUsersModalComponent,
        ChallengesHistoryComponent,
        ChallengesListComponent,
        ChallengesSettingsComponent,
        CleanIdPipe,
        CoachingEffectivenessComponent,
        CoinHistoryComponent,
        CoinsEarnedComponent,
        CommandCenterComponent,
        CommandCenterGroupSelectorComponent,
        CommandCenterOnboardingComponent,
        CompanyEditSsoComponent,
        CompanySettingsComponent,
        ConfigureBoardConnect3Component,
        ConfigureBoardMilestoneComponent,
        ConfigureEligibilityBracketsComponent,
        ConfigureEligibilityComponent,
        ConfigureEstimatorComponent,
        ConfigureEstimatorPopupComponent,
        ConfigureFoldersComponent,
        ConfigureMetricComponent,
        ConfigureNameComponent,
        ConfigureQualifierComponent,
        ConfigureRewardsBracketsComponent,
        ConfigureRewardsBullseyeComponent,
        ConfigureRewardsConnect3Component,
        ConfigureRewardsMilestoneComponent,
        ConfigureRewardsMultiplierComponent,
        ConfigureRewardsRaffleComponent,
        ConfigureRewardsTopDogComponent,
        ConfigureScheduleBracketsComponent,
        ConfigureScheduleComponent,
        ConfirmDialogComponent,
        Connect3MetricPopupComponent,
        ContactListComponent,
        ContactListDetailsComponent,
        ContactListImageCellRendererComponent,
        ContactListSettingsComponent,
        ContactStateCellRendererComponent,
        ContactStatesSkillSettingsComponent,
        ContextMenuAwardsDialogComponent,
        CreateNewDashboardComponent,
        CreateNewReportModalComponent,
        CreateReportSubscriptionComponent,
        CurrencyPendingExportButtonComponent,
        CurrentAgentStatesComponent,
        CurrentAgentStatesPmComponent,
        CurrentAgentStatesPmGraphComponent,
        CurrentAgentStatesPmTableComponent,
        CurrentAgentStatesSettingsComponent,
        CurrentHoldTimesComponent,
        CurrentHoldTimesPmComponent,
        CustomBadgeCreatorComponent,
        CustomDialogComponent,
        CustomMetricFormatterPipe,
        CvAdminAwardsComponent,
        CvAdminBudgetComponent,
        CvAdminBudgetHistoryComponent,
        CvAdminBudgetMeterComponent,
        CvAdminBudgetNotificationsComponent,
        CvAdminBudgetSetupComponent,
        CvAdminBudgetTitleHeaderComponent,
        CvAdminChallengeComponent,
        CvAdminGamesComponent,
        CvAdminGameHistorySpecificDetailsComponent,
        CvAdminLandingComponent,
        CvAngularLoadingOverlayComponent,
        CvAwardHistoryModalCellRendererComponent,
        CvAwardHistoryModalComponent,
        CvConnect3AllResultRenderComponent,
        CVGaugeComponent,
        CvGameEffectivenessComponent,
        CvLoaderComponent,
        CvLocalizedAttrsDirective,
        CvLocalizedPlaceholderDirective,
        CVLocalizedTextDirective,
        CvMarketplaceCartDrawerComponent,
        CvMarketplaceFilterComponent,
        CvMarketplaceProductsFilterPipe,
        CvMarketplaceShoppingCartCarouselComponent,
        CvMarketplaceShoppingCartCategoriesLandingComponent,
        CvMarketplaceShoppingCartComponent,
        CvMarketplaceShoppingCartFeaturedComponent,
        CvMarketplaceShoppingCartHomeComponent,
        CvMarketplaceShoppingCartOrdersComponent,
        CvMarketplaceShoppingCartProductDetailsComponent,
        CvMarketplaceShoppingCartWishlistComponent,
        CvNumberLocalizePipe,
        CvOrdinalLocalizePipe,
        CvPointStoreNewEditProductComponent,
        CvPointStoreProductAssignmentCxoneComponent,
        CvPointStoreProductInformationCxoneComponent,
        CvPointStoreProductSettingCxoneComponent,
        CvPointStoreProductSummaryCxoneComponent,
        CvPointStoreProductUploadCxoneComponent,
        CxoneChallengesLeadCellRendererComponent,
        CxoneCheckboxCellComponent,
        CxoneCheckboxHeaderComponent,
        CxoneDashboardNameCellRendererComponent,
        CXOneFirstPhaseIntegrationComponent,
        CxoneHighlightSearchCellRendererComponent,
        CxoneLoginsAssignToolComponent,
        CxoneOrderManagementComponent,
        CxoneOrderManagementGridComponent,
        CxoneOrderManagementGridLoaderComponent,
        CxoneOrderManagementGridProductComponent,
        CxoneOrderManagementGridTextContainerComponent,
        CxoneOrderManagementNotesModalComponent,
        CxoneOrderManagementNotesTooltipComponent,
        CxoneOrderPlacedComponent,
        CxoneRangeSliderComponent,
        CxoneSentimentCellRendererComponent,
        CxoneTruncateTextCellRendererComponent,
        DashboardAccessComponent,
        DashboardAssignmentComponent,
        DashboardAssignmentPermissionsRendererComponent,
        DashboardFilterSlideoutComponent,
        DashboardNameRendererComponent,
        DashboardProjectionContentComponent,
        DashboardsUseradminComponent,
        DashboardWindowComponent,
        DateRangeSelectorComponent,
        DeleteBtnRenderedComponent,
        DeleteSubscriptionComponent,
        DescriptionCellRendererComponent,
        DetailsUseradminComponent,
        DispositionsComponent,
        DowSelectorComponent,
        EditMetricComponent,
        EncodeColorPipe,
        ExpandedSummaryComponent,
        ExpandedSummaryCxoneComponent,
        ExpandedSummaryPmComponent,
        ExpandedSummarySettingsComponent,
        ExtendedKpiComponent,
        ExtendedKpiItemComponent,
        FavoriteButtonRendererComponent,
        FilesizeformatPipe,
        FilterPipe,
        FilterTextPipe,
        FooterButtonRenderedComponent,
        FooterEmptyRenderedComponent,
        FooterSubtotalRenderedComponent,
        FormatNumericTypePipe,
        FormDisplayComponent,
        FormsAssignComponent,
        FormsComponent,
        GameHistoryBreakdownEffectivenessComponent,
        GamesAddEditComponent,
        GamesConfigureComponent,
        GamesDetailsComponent,
        GamesDetailsModalComponent,
        GamesFilterPipe,
        GamesHistoryComponent,
        GamesHistoryExportButtonComponent,    
        GamesHistoryHealthReportComponent,
        GamesHistoryTableComponent,
        GamesLandingComponent,
        GamesRunningByTypeComponent,
        GamesRunningModalComponent,
        GamificationDetailPageComponent,
        GamificationExportComponent,
        GamificationPageComponent,
        GeneralWallboardSettingsSelectorComponent,
        GenericDowSelectorComponent,
        GenericExportComponent,
        GenericMetricFormatterPipe,
        GiveAwardPopupComponent,
        GridTemplateComponent,
        GroupByPipe,
        GroupSelectorComponent,
        GroupViewBySelectorComponent,
        HealthReportExportButtonComponent,
        HealthReportSpecificDetailsComponent,
        HealthReportTopPerformersComponent,
        HeatmapComponent,
        ImageFallbackDirective,
        ImageUploadComponent,
        ImgCropComponent,
        InputNumericFormatDirective,
        IntegrationMongoLogsCellRendererComponent,
        IntegrationMongoLogsComponent,
        InteractiveBarComponent,
        IntervalComboComponent,
        IntervalComboSettingsComponent,
        IntervalSelectorComponent,
        KpiComponent,
        LaunchWallboardComponent,
        LaunchWallboardPreviewComponent,
        LeaderboardComponent,
        LeaderboardMyMetricComponent,
        LeaderboardRankCellRendererComponent,
        LimitToPipe,
        LinkedContactsComponent,
        LinkedContactsDetailsComponent,
        ListFilterPipe,
        LoginLogoutComponent,
        ManageAvailableDashboardsComponent,
        ManageReportsComponent,
        MarketplaceOrdersModalComponent,
        MarketplaceOrdersTableComponent,
        MarketplaceOrdersTableComponentComponent,
        MarketplaceOverviewComponent,
        MarketplaceProductsModalComponent,
        MetricComponentModalComponent,
        MetricComponentPreviewComponent,
        MetricDefinitionAssignmentComponent,
        MetricDefinitionsLandingComponent,
        MetricFormulaComponent,
        MetricReviewComponent,
        MetricReviewSettingsComponent,
        MetricSelectorComponent,
        MetricSummaryComponent,
        MilestoneBadgesRendererComponent,
        MilestoneResultsRendererComponent,
        ModuleContainerComponent,
        ModuleCustomSettingSectionComponent,
        ModuleCxoneCustomSettingSectionDirective,
        ModuleErrorComponent,
        ModuleLegacyCustomSettingSectionDirective,
        ModuleLegacySettingsModalComponent,
        ModulePreviewComponent,
        ModuleSubscriptionSettingsContainerComponent,
        MultiSelectComponent,
        MyRankingComponent,
        NavigationHeaderMenuComponent,
        NavigationSidebarClassDirective,
        NewSystemTemplateComponent,
        NgModelChangeDebouncedDirective,
        NgTemplateComponent,
        NgTemplateSettingsComponent,
        NgxCleaveDirective,
        NotepadComponent,
        NumberLocalizePipe,
        ObjectiveAddEditComponent,
        ObjectiveAssignComponent,
        ObjectiveGroupsAssignedComponent,
        ObjectiveGroupsCardViewComponent,
        ObjectiveLandingComponent,
        ObjectiveMetricsAssignedComponent,
        ObjectivesDetailsComponent,
        ObjectiveTimePipe,
        OpenExistingDashboardComponent,
        OpenExistingTemplateComponent,
        OrderByPipe,
        OwnerCellRendererComponent,
        PackagesUseradminComponent,
        PageAccessCellRenderer,
        PageErrorStateComponent,
        PermissionAssignBoxComponent,
        PermissionCellRendererComponent,
        PermissionsUseradminComponent,
        PickGameTypeComponent,
        PointStoreAssignGroupAttrComponent,
        PointStoreCxoneSidebarComponent,
        PointStoreEditComponent,
        PointStoreNavigationBarComponent,
        PointStoreOrdersAdminComponent,
        PointStoreProductAssignmentComponent,
        PointStoreProductGroupSelectorComponent,
        PointStoreProductInformationComponent,
        PointStoreProductLandingCardComponent,
        PointStoreProductLandingCardCvComponent,
        PointStoreProductLandingListComponent,
        PointStoreProductLandingPageComponent,
        PointStoreProductLandingThumbnailComponent,
        PointStoreProductSettingComponent,
        PointStoreProductSummaryComponent,
        PointStoreProductUploadComponent,
        PreventMenuCloseDirective,
        ProductsFilterPipe,
        ProfilePictureApprovalComponent,
        PublishBarComponent,
        QtyInputRenderedComponent,
        QueueCounterComponent,
        QueueCounterSettingsComponent,
        QuickDateRangeSelectorComponent,
        RaffleRewardsDetailsComponent,
        RecordingsDetailsComponent,
        RecordingsLandingComponent,
        ReleaseModalComponent,
        ReorderBtnRenderedComponent,
        ReportingSetComponent,
        ReportingSetSettingsComponent,
        ResetConfirmDialogComponent,
        ResponsiveDashboardComponent,
        RevertPayoutDetailsComponent,
        RewardEstimatorTableComponent,
        RoleSelectorCellRendererComponent,
        SafeUrlPipe,
        SaveDashboardModalComponent,
        ScheduleAdherenceComponent,
        ScheduleAdherenceSettingsComponent,
        ScheduleAdvancedOptionsComponent,
        SelectedDashboardDetailsComponent,
        SelectedUserLabelComponent,
        SendToSubscriptionComponent,
        SentimentLegendComponent,
        ServiceLevelComponent,
        SettingsSlideoutComponent,
        ShadowBoxingPreviewComponent,
        ShadowBoxingProgressComponent,
        ShadowBoxingResultComponent,
        SharedDashboardComponent,
        ShareTextRendererComponent,
        ShareViaUrlComponent,
        ShoppingCartLandingComponent,
        ShoppingCartListComponent,
        SidebarModuleListComponent,
        SingleAttributeSelectorComponent,
        SingleSelectComponent,
        SolRangeSliderWrapperComponent,
        StartOnPipe,
        SubmitFeedbackComponent,
        SubscriptionManagementComponent,
        SubscriptionManagementEditComponent,
        SubscriptionModalComponent,
        SubscriptionSchedulerComponent,
        SubtotalRenderedComponent,
        SuggestCoachingModalComponent,
        SummaryComboComponent,
        SysTemplateActionCellRendererComponent,
        SystemplateCellRendererComponent, 
        TakeOwnershipComponent,
        TaskbarComponent,
        TasksComponent,
        TasksModalComponent,
        TeamsHistoryTableComponent,
        TemplateListModalComponent,
        ThresholdRangeValidator,
        TimeEntryDirective,
        TimePickerComponent,
        TimeRangeSelectorComponent,
        TimeSliderComponent,
        TopCallTimesComponent,
        TopCallTimesSettingsComponent,
        TrendingComponent,
        UniquePipe,
        UsageStatsExportButtonComponent,
        UserAdminComponent,
        UserIdleComponent,
        UserListComponent,
        WallboardColumnSortSelectorComponent,
        WallboardsAssignComponent,
        WallboardsComponent,
        WallboardViewChallengesComponent,
        WallboardViewCurrentAgentStatesComponent,
        WallboardViewCurrentAgentStatesResponsiveComponent,
        WallboardViewCustomAchievementComponent,
        WallboardViewCustomAgentCounterComponent,
        WallboardViewCustomComponent,
        WallboardViewCustomGaugeComponent,
        WallboardViewCustomImageComponent,
        WallboardViewCustomKpiComponent,
        WallboardViewCustomSummaryComponent,
        WallboardViewCustomTextComponent,
        WallboardViewCustomThermometerComponent,
        WallboardViewCustomTopComponent,
        WallboardViewErrorComponent,
        WallboardViewGamesComponent,
        WallboardViewImageComponent,
        WallboardViewLeaderboardComponent,
        WallboardViewMainComponent,
        WallboardViewMarketplaceComponent,
        WallboardViewRacingComponent,
        WallboardViewScorecardComponent,
        WallboardViewSpotlightComponent,
        WallboardViewSummaryComponent,
        WallboardViewVideoComponent,
        WarningDialogComponent,
        WebhelpETSComponent,
        WebhelpETSSettingsComponent,
        WidgetAccessCellRendererComponent,
        WidgetThresholdsModalComponent,
        WorkAidsComponent,
        WorkAidsNewComponent,
        WorkspaceLandingComponent,
        WorkspaceNewTabLandingComponent,
    ],
    imports: [
        AgGridModule,
        BrowserAnimationsModule,
        BrowserModule,
        ButtonMenuSolModule,
        CheckboxSolModule,
        ClipboardModule,
        ColorPickerModule,
        DateRangePickerModule,
        DatePickerModule,
        DragDropModule,
        DropdownModule,
        DynamicDialogModule,
        EditorModule,
        FormsModule,
        FloatingMenuModule,
        GridSolModule,
        I18NextModule.forRoot(),
        DropdownSolModule,
        RadioSolModule,
        NumericSelectorSolModule,
        ButtonSolModule,
        GridsterModule,
        HighchartsChartModule,
        HttpClientModule,
        ImageCropperModule,
        InlineNotificationModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatStepperModule,
        MatTooltipModule,
        ModalSolModule,
        WizardModule,
        SolTextAreaModule,
        TimePickerModule,
        NgbModule,
        NgChartsModule,
        NouisliderModule,
        OmnibarSolModule,
        OverlayscrollbarsModule,
        PopoverModule,
        ProgressBarModule,
        QueryBuilderModule,
        RangeSliderSolModule,
        ReactiveFormsModule,
        ScrollingModule,
        SelectedTagsSolModule,
        SlideToggleSolModule,
        SolButtonToggleGroupModule,
        SolCardModule,
        SolChipModule,
        SolStatusIndicatorModule,
        SolTabsModule,
        SolTooltipModule,
        SpinnerSolModule,
        SolTextInput,
        ToastrManagerSolModule,
        TooltipModule,
    ],
    providers: [
        [CVApiService],
        { provide: "$window", useFactory: () => window },
        { provide: WINDOW_INJECTION_TOKEN, useValue: window },
        { provide: "$document", useFactory: () => document },
        {
            provide: ConfigurationCoreService,
            useClass: ConfigurationCoreService,
        },
        {
            provide: LOCALE_ID,
            useClass: DynamicLocaleId,
            deps: [I18NEXT_SERVICE],
        },
        {
            provide: LocalizationInitializer,
            useClass: LocalizationInitializer,
            deps: [I18NEXT_SERVICE, HttpClient, ConfigurationCoreService],
        },
        {
            provide: APP_INITIALIZER,
            multi: true,
            useFactory: AppInitializerFactory,
            deps: [
                I18NEXT_SERVICE,
                LocalizationInitializer,
                ConfigurationCoreService,
                CVApiService,
            ],
        },
        [ConfigurationService],
        AnalyticsService,
        ArraySortPipe,
        AssignBoxPipe,
        BoldTextPipe,
        CustomMetricFormatterPipe,
        CvNumberLocalizePipe,
        CvOrdinalLocalizePipe,
        DatePipe,
        DecimalPipe,
        DialogService,
        EncodeColorPipe,
        FilesizeformatPipe,
        FilterTextPipe,
        FormatNumericTypePipe,
        GamesFilterPipe,
        GenericMetricFormatterPipe,
        ProductsFilterPipe,
        ThresholdRangeValidator,
        localeInitializerProvider,
        TranslationPipe,
        UserIdleService,
    ],
    bootstrap: [],
})
export class AppModule implements DoBootstrap {
    /** List of custom elements to export (sort alphabetically) */
    private elements: any[] = [
        [AboutComponent, "about"],
        [AcdCallbackComponent, "cvAcdCallback"],
        [AddCustomHierarchyComponent, "addCustomHierarchy"],
        [AddEditAssignBoxComponent, "addEditAssignBox"],
        [AgentOrderHistoryComponent, "agentOrderHistory"],
        [AgGridIChartTemplateComponent, "agGridIchartTemplate"],
        [AngularAssignToolComponent, "cvAngularAssignToolAngular"],
        [AnnouncementsComponent, "announcementsAdmin"],
        [AnnouncementsNewComponent, "announcementsNew"],
        [AttributeSelectorComponent, "attributeSelector"],
        [AwardCardComponent, "awardCard"],
        [AwardsExportButtonComponent, "awardsExportButton"], // access to this component as generic-export
        [AwardsHistoryListComponent, "awardsHistoryList"],
        [AwardsCardMenuComponent, "awardsCardMenu"],
        [AwardsLandingComponent, "awardsLanding"],
        [AwardsAddEditComponent, "awardsAddEdit"],
        [AwardedPopupComponent, "awardedPopup"],
        [BadgesEarnedComponent, "badgesEarned"],
        [BadgeSelectorComponent, "badgeSelector"],
        [BANCOITAUComponent, "cvBancoItau"],
        [BaremetricsCalendarComponent, "baremetricsCalendar"],
        [BattleBoatChallengeComponent, "battleBoatChallenge"],
        [BattleBoatDetailsComponent, "battleBoatDetails"],
        [BattleBoatShotComponent, "battleBoatShot"],
        [BracketViewComponent, "bracketView"],
        [BroadcastDetailsComponent, "broadcastDetails"],
        [BroadcastAssignComponent, "broadcastAssign"],
        [BudgetExportButtonComponent, "budgetExportButton"],
        [CalculatorComponent, "calculator"],
        [ChallengeCardViewComponent, "challengeCardView"],
        [ChallengeBattleBoatResultComponent, "challengeBattleBoatResult"],
        [ChallengedUsersModalComponent, "challengedUsersModal"],
        [ChallengesHistoryComponent, "challengesHistory"],
        [ChallengesListComponent, "challengesList"],
        [ChallengesSettingsComponent, "challengesSettings"],
        [CoinHistoryComponent, "coinHistory"],
        [CoinsEarnedComponent, "coinsEarned"],
        [CommandCenterComponent, "commandCenter"],
        [CommandCenterGroupSelectorComponent, "commandCenterGroupSelector"],
        [CommandCenterOnboardingComponent, "commandCenterOnboarding"],
        [CompanySettingsComponent, "cvCompanySettings"],
        [ConfigureBoardConnect3Component, "configureBoardConnect3"],
        [ConfigureBoardMilestoneComponent, "configureBoardMilestone"],
        [ConfigureEligibilityBracketsComponent, "configureEligibilityBrackets"],
        [ConfigureEligibilityComponent, "configureEligibility"],
        [ConfigureEstimatorComponent, "configureEstimator"],
        [ConfigureEstimatorPopupComponent, "configureEstimatorPopup"],
        [ConfigureFoldersComponent, "configureFolders"],
        [ConfigureMetricComponent, "configureMetric"],
        [ConfigureNameComponent, "configureName"],
        [ConfigureQualifierComponent, "configureQualifier"],
        [
            ConfigureRewardsBracketsComponent,
            "configureRewardsBracketsTournament",
        ],
        [ConfigureRewardsBullseyeComponent, "configureRewardsBullseye"],
        [ConfigureRewardsConnect3Component, "configureRewardsConnect3"],
        [ConfigureRewardsMilestoneComponent, "configureRewardsMilestone"],
        [ConfigureRewardsMultiplierComponent, "configureRewardsMultiplier"],
        [ConfigureRewardsRaffleComponent, "configureRewardsRaffle"],
        [ConfigureRewardsTopDogComponent, "configureRewardsTopDog"],
        [ConfigureScheduleComponent, "configureSchedule"],
        [ConfigureScheduleBracketsComponent, "configureScheduleBrackets"],
        [ContextMenuAwardsDialogComponent, "contextMenuAwardsDialog"],
        [Connect3MetricPopupComponent, "connect3MetricPopup"],
        [CreateNewDashboardComponent, "dashboardCreateNew"],
        [CurrencyPendingExportButtonComponent, "pendingExportButton"],
        [CustomBadgeCreatorComponent, "customBadgeCreator"],
        [CustomDialogComponent, "customDialog"],
        [CVGaugeComponent, "gauge"],
        [CvLoaderComponent, "cvLoader"],
        [CvMarketplaceCartDrawerComponent, "cvMarketplateCartDrawer"],
        [CvMarketplaceShoppingCartComponent, "cvMarketplaceShoppingCart"],
        [
            CvMarketplaceShoppingCartOrdersComponent,
            "cvMarketplaceShoppingCartOrders",
        ],
        [
            CvMarketplaceShoppingCartProductDetailsComponent,
            "cvMarketplaceShoppingCartProductDetails",
        ],
        [
            CvMarketplaceShoppingCartWishlistComponent,
            "cvMarketplaceShoppingCartWishlist",
        ],
        [CvPointStoreNewEditProductComponent, "cvPointStoreNewEditProduct"],
        [
            CvPointStoreProductAssignmentCxoneComponent,
            "cvPointStoreProductAssignmentCxone",
        ],
        [
            CvPointStoreProductInformationCxoneComponent,
            "cvPointStoreProductInformationCxone",
        ],
        [
            CvPointStoreProductSettingCxoneComponent,
            "cvPointStoreProductSettingCxone",
        ],
        [
            CvPointStoreProductSummaryCxoneComponent,
            "cvPointStoreProductSummaryCxone",
        ],
        [
            CvPointStoreProductUploadCxoneComponent,
            "cvPointStoreProductUploadCxone",
        ],
        [CvAdminLandingComponent, "adminLanding"],
        [CxoneRangeSliderComponent, "cvCxoneRangeSlider"],
        [DashboardAccessComponent, "cvDashboardAccess"],
        [DashboardFilterSlideoutComponent, "dashboardFilterSlideout"],
        [DashboardProjectionContentComponent, "dashboardProjectionContent"],
        [DashboardWindowComponent, "dashboard-window"],
        [DateRangeSelectorComponent, "dateRangeSelector"],
        [DispositionsComponent, "dispositions"],
        [DowSelectorComponent, "dowSelector"],
        [ExpandedSummaryComponent, "cvExpandedSummary"],
        [ExpandedSummaryCxoneComponent, "cvExpandedSummaryCxone"],
        [ExpandedSummaryPmComponent, "cvExpandedSummaryPm"],
        [ExpandedSummarySettingsComponent, "cvExpandedSummaryInternalSettings"],
        [ExtendedKpiComponent, "extendedKpi"],
        [FormsComponent, "forms"],
        [GamesAddEditComponent, "gamesAddEdit"],
        [GamesConfigureComponent, "gamesAddEditConfigure"],
        [GamesDetailsModalComponent, "gamesDetailsModal"],
        [
            GameHistoryBreakdownEffectivenessComponent,
            "gameHistoryBreakdownEffectiveness",
        ],
        [GamesHistoryComponent, "gamesHistory"],
        [GamesHistoryTableComponent, "gamesHistoryTable"],
        [GamesHistoryHealthReportComponent, "gamesHistoryHealthReport"],
        [GamesLandingComponent, "gamesLanding"],
        [GamesRunningByTypeComponent, "gamesRunningByType"],
        [GamesRunningModalComponent, "gamesRunningModal"],
        [GamificationExportComponent, "gamificationExport"],
        [GiveAwardPopupComponent, "giveAwardPopup"],
        [GroupSelectorComponent, "groupSelector"],
        [HealthReportExportButtonComponent, "healthReportButtonExport"],
        [HealthReportSpecificDetailsComponent, "healthReportSpecificDetails"],
        [HealthReportTopPerformersComponent, "healthReportTopPerformers"],
        [IntegrationMongoLogsComponent, "integrationMongoLogs"],
        [IntervalComboComponent, "intervalCombo"],
        [IntervalComboSettingsComponent, "intervalComboSettings"],
        [KpiComponent, "widget"],
        [LaunchWallboardComponent, "cvLaunchWallboard"],
        [LeaderboardComponent, "ranking"],
        [LinkedContactsComponent, "cvLinkedContacts"],
        [LoginLogoutComponent, "loginLogout"],
        [ManageAvailableDashboardsComponent, "manageAvailableDashboards"],
        [ManageReportsComponent, "managereports"],
        [MarketplaceOrdersModalComponent, "marketplaceOrdersModal"],
        [MarketplaceOrdersTableComponent, "marketplaceOrdersTable"],
        [MarketplaceOverviewComponent, "marketplaceOverview"],
        [MarketplaceProductsModalComponent, "marketplaceProductModal"],
        [MetricDefinitionsLandingComponent, "metricDefinitionsLanding"],
        [CxoneOrderManagementComponent, "cxoneOrderManagement"],
        [MetricReviewComponent, "metricReview"],
        [MilestoneBadgesRendererComponent, "milestoneBadgesRenderer"],
        [MilestoneResultsRendererComponent, "milestoneResultsRenderer"],
        [ModuleContainerComponent, "moduleContainer"],
        [ModuleErrorComponent, "moduleError"],
        [ModulePreviewComponent, "modulePreview"],
        [NavigationHeaderMenuComponent, "navigationHeaderMenu"],
        [NgTemplateComponent, "ts-template"],
        [ObjectiveLandingComponent, "cvObjectiveLanding"],
        [PickGameTypeComponent, "pickGameType"],
        [PointStoreEditComponent, "pointStoreEdit"],
        [PointStoreNavigationBarComponent, "pointStoreNavigationBar"],
        [PointStoreOrdersAdminComponent, "pointStoreOrdersAdminComponent"],
        [PointStoreProductAssignmentComponent, "pointStoreProductAssignment"],
        [PointStoreProductInformationComponent, "pointStoreProductInformation"],
        [PointStoreProductLandingListComponent, "pointStoreProductLandingList"],
        [PointStoreProductLandingPageComponent, "pointStoreProductLandingPage"],
        [
            PointStoreProductLandingThumbnailComponent,
            "pointStoreProductLandingThumbnail",
        ],
        [PointStoreProductSettingComponent, "pointStoreProductSetting"],
        [PointStoreProductSummaryComponent, "pointStoreProductSummary"],
        [PointStoreProductUploadComponent, "pointStoreProductUpload"],
        [PublishBarComponent, "publishBar"],
        [QueueCounterComponent, "queueCounter"],
        [RecordingsLandingComponent, "recordingsLandingMain"],
        [RaffleRewardsDetailsComponent, "raffle-rewards-details"],
        [ReleaseModalComponent, "releaseModal"],
        [ReportingSetComponent, "reportingSetModule"],
        [ResponsiveDashboardComponent, "responsiveDashboard"],
        [RevertPayoutDetailsComponent, "revertPayoutDetails"],
        [RewardEstimatorTableComponent, "rewardEstimatorTable"],
        [SaveDashboardModalComponent, "cvSaveDashboardModal"],
        [SelectedDashboardDetailsComponent, "selectedDashboardsDetails"],
        [ShadowBoxingPreviewComponent, "shadowBoxingPreview"],
        [ShadowBoxingProgressComponent, "shadowBoxingProgress"],
        [SelectedUserLabelComponent, "selectedUserLabel"],
        [SettingsSlideoutComponent, "settingsSlideout"],
        [ShadowBoxingResultComponent, "shadowBoxingResult"],
        [SharedDashboardComponent, "cvSharedDashboard"],
        [ShareViaUrlComponent, "cvShareViaUrl"],
        [ShoppingCartLandingComponent, "shoppingCartLanding"],
        [ShoppingCartListComponent, "shoppingCartList"],
        [SidebarModuleListComponent, "sidebarModuleList"],
        [SubscriptionManagementComponent, "subscriptionManagement"],
        [SubscriptionModalComponent, "cvSubscriptionModal"],
        [SubscriptionSchedulerComponent, "cvSubscriptionScheduler"],
        [SummaryComboComponent, "summaryCombo"],
        [TakeOwnershipComponent, "cvTakeOwnership"],
        [TaskbarComponent, "moduleTaskbar"],
        [TeamsHistoryTableComponent, "teamsHistoryTable"],
        [TimeSliderComponent, "timeSlider"],
        [TopCallTimesComponent, "topCallTime"],
        [UsageStatsExportButtonComponent, "usageStatsExportButton"], // access to this component as generic-export
        [UserAdminComponent, "usersList"],
        [WallboardsComponent, "wallboards"],
        [WallboardViewMainComponent, "wallboardViewMain"],
        [WorkAidsComponent, "workAidsAdmin"],
        [WorkAidsNewComponent, "workAidsNew"],
        [WorkspaceLandingComponent, "cvWorkspaceLanding"],
        [WorkspaceNewTabLandingComponent, "workspaceNewTab"],
    ];

    /** List of dashboard modules (sort automatically) */
    /** If a module has export/subscribe it still needs to be in the elements array */
    private modules: any[] = [
        [AcdCallbackComponent, "cv-acd-callback"],
        [AgentCounterComponent, "agent-counter"],
        [BANCOITAUComponent, "cv-banco-itau"],
        [CalculatorComponent, "calculator"],
        [CalculatedMetricBreakdownComponent, "calculated-metric-breakdown"],
        [CallArrivalComponent, "call-arrival"],
        [CoachingEffectivenessComponent, "coaching-effectiveness"],
        [ContactListComponent, "contact-list"],
        [CurrentAgentStatesComponent, "current-agent-states"],
        [CurrentAgentStatesPmComponent, "current-agent-states-pm"],
        [CurrentHoldTimesComponent, "current-hold-times"],
        [CurrentHoldTimesPmComponent, "current-hold-times-pm"],
        [CVGaugeComponent, "gauge"],
        [
            "cv-cxone-agent-adherence-variance",
        ],
        [
            "cxone-evaluation-coaching-trend",
        ],
        [DispositionsComponent, "dispositions"],
        [ExpandedSummaryComponent, "cv-expanded-summary"],
        [ExpandedSummaryCxoneComponent, "cv-expanded-summary-cxone"],
        [ExpandedSummaryPmComponent, "cv-expanded-summary-pm"],
        [ExtendedKpiComponent, "extended-kpi"],
        [HeatmapComponent, "geo-tag-data"],
        [IntervalComboComponent, "interval-combo"],
        [KpiComponent, "widget"],
        [LeaderboardComponent, "ranking"],
        [LinkedContactsComponent, "cv-linked-contacts"],
        [LoginLogoutComponent, "login-logout"],
        [MetricReviewComponent, "metric-review"],
        [MyRankingComponent, "cv-my-ranking"],
        [NgTemplateComponent, "ts-template"],
        [NotepadComponent, "notepad"],
        [QueueCounterComponent, "queue-counter"],
        [ReportingSetComponent, "reporting-set-module"],
        [ServiceLevelComponent, "service-level"],
        [ScheduleAdherenceComponent, "cv-schedule-adherence"],
        [SummaryComboComponent, "summary-combo"],
        [TasksComponent, "tasks"],
        [TopCallTimesComponent, "top-call-time"],
        [TrendingComponent, "trending"],
        [WebhelpETSComponent, "cv-webhelp-custom"],
    ];

    /** List of dashboard modules settings (sort automatically) */
    private moduleSettings: any[] = [
        [AgentCounterSettingsComponent, "agent-counter-settings"],
        [CallArrivalSettingsComponent, "call-arrival-settings"],
        [
            CalculatedMetricBreakdownSettingsComponent,
            "calculated-metric-breakdown-settings",
        ],
        [ContactListSettingsComponent, "contact-list-settings"],
        [
            ContactStatesSkillSettingsComponent,
            "cv-contact-states-skill-settings",
        ],
        [CurrentAgentStatesSettingsComponent, "current-agent-states-settings"],
        [
            "cxone-evaluation-coaching-trend-settings",
        ],
        [
            "cv-evaluator-calibration-settings",
        ],
        [ExpandedSummarySettingsComponent, "cv-expanded-summary-settings"],
        [
            "cv-cxone-interaction-summary-settings",
        ],
        [IntervalComboSettingsComponent, "interval-combo-settings"],
        [MetricReviewSettingsComponent, "metric-review-settings"],
        [NgTemplateSettingsComponent, "ts-template-settings"],
        [
            "cv-qm-evaluations-coaching-settings",
        ],
        [
            "cv-qm-evaluator-performance-settings",
        ],
        [QueueCounterSettingsComponent, "queue-counter-settings"],
        [ReportingSetSettingsComponent, "reporting-set-module-settings"],
        [ScheduleAdherenceSettingsComponent, "cv-schedule-adherence-settings"],
        [TopCallTimesSettingsComponent, "top-call-time-settings"],
        [WebhelpETSSettingsComponent, "cv-webhelp-custom-settings"],
    ];

    constructor(
        private injector: Injector,
        private solTranslationService: TranslationService,
        private localizationInitializer: LocalizationInitializer
    ) { }

    ngDoBootstrap() {
        // load translation strings
        try {
            this.solTranslationService.setTranslations(
                this.localizationInitializer.getSolTranslations()
            );
        } catch (error) {
            console.error("Error setting sol translations:", error);
        }

        // create custom elements
        for (const [component, name] of this.elements) {
            const el = createCustomElement(component, {
                injector: this.injector,
            });
            const ceName = `${name.toLowerCase()}-ce`;
            customElements.define(ceName, el);

            if (window["angular"]) {
                const ng1El = createNg1Wrapper(ceName, component, {
                    injector: this.injector,
                });

                angular.module("ClearViewApp").component(name, ng1El);
            }
        }

        // add dashboard modules
        const angularModuleService = new AngularModuleServiceBase(true);
        for (const [component, name] of this.modules) {
            angularModuleService.addAngularModule(name, component);
        }

        for (const [component, name] of this.moduleSettings) {
            angularModuleService.addAngularModuleSettings(name, component);
        }
    }
}
